import createLucideIcon from '../createLucideIcon';

const Unlock = createLucideIcon('UnlockIcon', [
  [
    'rect',
    {
      x: '3',
      y: '11',
      width: '18',
      height: '11',
      rx: '2',
      ry: '2',
      key: 'biyj2e',
    },
  ],
  ['path', { d: 'M7 11V7a5 5 0 0 1 9.9-1', key: '1mm8w8' }],
]);

export default Unlock;
